import { PipeTransform } from '@angular/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var FormatDurationPipe = /** @class */ (function () {
    function FormatDurationPipe(fuseTranslationLoaderService, translate) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.translate = translate;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    FormatDurationPipe.prototype.transform = function (value, unit) {
        var duration = moment.duration(value, unit);
        var days = duration.asDays();
        if (days >= 1) {
            var daysAsString = days.toFixed(0);
            return daysAsString + " " + (daysAsString === '1' ? this.translate.instant('DURATION.DAY') : this.translate.instant('DURATION.DAYS'));
        }
        var hours = duration.asHours();
        if (hours >= 1) {
            var hoursAsString = hours.toFixed(0);
            return hoursAsString + " " + (hoursAsString === '1' ? this.translate.instant('DURATION.HOUR') : this.translate.instant('DURATION.HOURS'));
        }
        var minutes = duration.asMinutes();
        var minutesAsString = minutes.toFixed(0);
        return minutesAsString + " " + (minutesAsString === '1' ? this.translate.instant('DURATION.MINUTE') : this.translate.instant('DURATION.MINUTES'));
    };
    return FormatDurationPipe;
}());
export { FormatDurationPipe };
